export default __webpack_public_path__ + "static/media/DAIF_Extra3_In.b5e0d51c.mp4";